import React from 'react';
import ResponsiveInput from '../common/ResponsiveInput';

const PersonalInfo = ({ 
  personalInfo,
  updatePersonalInfo,
  handleNext,
  handlePrevious
}) => {
  const areAllFieldsFilled = () => {
    return Object.values(personalInfo).every(value => value.trim());
  };

  return (
    <div className="form-page-container">
      <div className="questions-grid">
        <div className="question-item">
          <label>What is your name?</label>
          <ResponsiveInput
            type="text"
            value={personalInfo.name}
            onChange={updatePersonalInfo}
            field="name"
            placeholder="Type your answer here"
          />
        </div>
        <div className="question-item">
          <label>What is your email ID?</label>
          <ResponsiveInput
            type="email"
            value={personalInfo.email}
            onChange={updatePersonalInfo}
            field="email"
            placeholder="Type your answer here"
          />
        </div>
        <div className="question-item">
          <label>What is the name of the hospital you are associated with?</label>
          <ResponsiveInput
            type="text"
            value={personalInfo.hospital || "" }
            onChange={updatePersonalInfo}
            field="hospital"
            placeholder="Type your answer here"
          />
        </div>
        <div className="question-item">
          <label>What is your designation?</label>
          <ResponsiveInput
            type="text"
            value={personalInfo.role}
            onChange={updatePersonalInfo}
            field="role"
            placeholder="Type your answer here"
          />
        </div>
      </div>
      <div className="button-group">
        <button 
          className="nav-button" 
          onClick={handleNext}
          disabled={!areAllFieldsFilled()}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default PersonalInfo;